const screenInputData = {
  TarimsalSulamaOnSurecler: [{"name":"ProjeID","type":"Int32","cardinality":1,"isExpandedPanel":null}],
	UserEdit: [{"name":"Username","type":"String","cardinality":1,"isExpandedPanel":null}],
	CatiGesOnSurecler: [{"name":"ProjeID","type":"Int32","cardinality":1,"isExpandedPanel":null}],
	ProjeDetay: [{"name":"ProjeID","type":"Int32","cardinality":1,"isExpandedPanel":null}],
	ProjeEdit: [{"name":"ProjeCategory","type":"String","cardinality":1,"isExpandedPanel":null},{"name":"ProjeID","type":"Int32","cardinality":1,"isExpandedPanel":null}],
	YeniProjeGenel: [{"name":"ProjeCategory","type":"String","cardinality":1,"isExpandedPanel":null}]
};

export class ScreenInputHelper {
  public static getScreenInputValue(screenName: string, inputName: string, value: string): any {
    switch (this.getScreenInputType(screenName, inputName)) {
      case "String":
        return value;
      case "Boolean":
        return value.toLowerCase() === "true";
      // TODO
    }

    return value;
  }

  private static getScreenInputType(screenName: string, inputName: string): string {
    const data = screenInputData[screenName]?.find((x) => x.Name === inputName);
    return data?.TypeName ? data.TypeName : "";
  }
}
